// src/pages/DebtStudio/components/Portfolios/Main/index.jsx

import React from "react";
import SectionCard from "components/SectionCard";
import { DateInput, DropdownSelect, TextInput } from "components/InputStyled";
import {
  SHARING_OPTIONS,
  normalizeSharing,
} from "lib/permissions";

import PortfolioComposition from "./portfolioComposition";

export default function PortfoliosMain({
  portfolio,
  draftName,
  draftDescription,
  setDraftName,
  setDraftDescription,
  draftSharing,
  setDraftSharing,

  // Period-end date (stored on portfolio, used for DS reports)
  draftPeriodEndDate,
  setDraftPeriodEndDate,

  canEdit,
  canChangeSharing,
  saving,

  // from parent Portfolios/index.jsx
  markMembersDirty = () => {},
}) {
  const isEditable = !!canEdit && !saving;
  const canEditSharing = !!canChangeSharing && !saving;

  return (
    <div className="space-y-4">
      {/* ───────────────── Portfolio Information ───────────────── */}
      <SectionCard title="Portfolio Info">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Name */}
          <TextInput
            label="Name"
            value={draftName || ""}
            onChange={(v) => setDraftName(v)}
            disabled={!isEditable}
            placeholder="Portfolio name"
            className="w-full"
          />

          {/* Description */}
          <TextInput
            label="Description"
            value={draftDescription || ""}
            onChange={(v) => setDraftDescription(v)}
            disabled={!isEditable}
            placeholder="Optional description"
            className="w-full"
          />

          <DropdownSelect
            label="Sharing"
            value={normalizeSharing(draftSharing)}
            onChange={(v) => {
              if (!canEditSharing) return;
              setDraftSharing?.(v);
            }}
            options={SHARING_OPTIONS}
            disabled={!canEditSharing}
            className="w-full"
          />
        </div>

        {/* Period End */}
        <div className="mt-4 max-w-xs">
          <DateInput
            label="Annual Period End (FY or Bond Year)"
            value={draftPeriodEndDate || ""}
            onChange={(v) => setDraftPeriodEndDate?.(v)}
            disabled={!isEditable}
            className="w-full"
          />
        </div>
      </SectionCard>

      {/* ───────────────── Portfolio Composition ───────────────── */}
      <PortfolioComposition
        portfolio={portfolio}
        canEdit={isEditable}
        markDirty={markMembersDirty}
      />
    </div>
  );
}
